import { Link, useParams } from 'react-router-dom';
import './auth.scss';
import { useCallback, useEffect, useState } from 'react';
import { authenticationHttpService } from '@myinnsworth/httpServices';

enum ConfirmationState {
    InvalidToken,
    ValidatingToken,
    Success
}

export default function ConfirmSignUp() {
    const params = useParams();
    const [state, setState] = useState<ConfirmationState>(ConfirmationState.ValidatingToken)
    
    const validateToken = useCallback(async () => {
        if(params.token) {
            const isValid = await authenticationHttpService.confirmRegistration(params.token!);
            setState(isValid ? ConfirmationState.Success : ConfirmationState.InvalidToken);
        }
    }, [params.token]);

    //First we need to validate the token
    useEffect(() => {
        validateToken();
    }, [validateToken]);

    return (<>
        {state === ConfirmationState.ValidatingToken && (<>
            <h6 className='text-center'>Validating...</h6>
        </>)}

        {state === ConfirmationState.Success && (<>
            <h6 className='text-center'>Success!  Your My.Innsworth account has been activated!</h6>
            <div className="spacing-l"></div>

            <div className="flex direction-column align-center">
                <Link className='btn primary medium back' to={"/auth/sign-in"} >Back to Login</Link>
            </div>
        </>)}

        {state === ConfirmationState.InvalidToken && (<>
            <h6 className='text-center'>Invalid confirmation token</h6>
            <div className="spacing-l"></div>

            <div className="flex direction-column align-center">
                <Link className='btn primary medium back' to={"/auth/sign-in"} >Back to Login</Link>
            </div>
        </>)}
    </>)
}